import React from 'react';
import { AdminLayout } from '../../components/layout/AdminLayout';
import { useTenant } from '../../lib/tenant-context';
import { useLoyaltyDashboard } from '../../lib/loyalty-hooks';
import { Card } from '../../components/ui/Card';
import { Users, Star, Gift, Trophy } from 'lucide-react';
import { formatCurrency } from '../../lib/utils';
export function LoyaltyDashboardPage() {
  const {
    restaurant,
    role,
    signOut
  } = useTenant();
  const {
    customers,
    loading
  } = useLoyaltyDashboard(restaurant.restaurant_id);
  const totalCustomers = customers.length;
  const totalPoints = customers.reduce((sum, c) => sum + (c.current_points || 0), 0);
  const totalRewardsAvailable = customers.reduce((sum, c) => sum + (c.available_rewards_count || 0), 0);
  const totalRewardsRedeemed = customers.reduce((sum, c) => sum + (c.redeemed_rewards_count || 0), 0);
  return <AdminLayout restaurant={restaurant} role={role} onSignOut={signOut} data-id="element-3220">
      <div className="p-6 max-w-7xl mx-auto space-y-6" data-id="element-3221">
        <div data-id="element-3222">
          <h1 className="text-2xl font-bold text-gray-900" data-id="element-3223">
            Programa de Lealtad
          </h1>
          <p className="text-gray-500" data-id="element-3224">
            Gestiona tus clientes frecuentes y beneficios
          </p>
        </div>

        {/* KPIs */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-3225">
          <Card className="p-6" data-id="element-3226">
            <div className="flex items-center gap-4" data-id="element-3227">
              <div className="w-12 h-12 bg-blue-50 rounded-xl flex items-center justify-center shrink-0" data-id="element-3228">
                <Users className="w-6 h-6 text-blue-600" data-id="element-3229" />
              </div>
              <div data-id="element-3230">
                <p className="text-sm text-gray-500 font-medium" data-id="element-3231">
                  Clientes Leales
                </p>
                <p className="text-2xl font-bold text-gray-900" data-id="element-3232">
                  {totalCustomers}
                </p>
              </div>
            </div>
          </Card>
          <Card className="p-6" data-id="element-3233">
            <div className="flex items-center gap-4" data-id="element-3234">
              <div className="w-12 h-12 bg-yellow-50 rounded-xl flex items-center justify-center shrink-0" data-id="element-3235">
                <Star className="w-6 h-6 text-yellow-600" data-id="element-3236" />
              </div>
              <div data-id="element-3237">
                <p className="text-sm text-gray-500 font-medium" data-id="element-3238">
                  Puntos Emitidos
                </p>
                <p className="text-2xl font-bold text-gray-900" data-id="element-3239">
                  {totalPoints}
                </p>
              </div>
            </div>
          </Card>
          <Card className="p-6" data-id="element-3240">
            <div className="flex items-center gap-4" data-id="element-3241">
              <div className="w-12 h-12 bg-green-50 rounded-xl flex items-center justify-center shrink-0" data-id="element-3242">
                <Gift className="w-6 h-6 text-green-600" data-id="element-3243" />
              </div>
              <div data-id="element-3244">
                <p className="text-sm text-gray-500 font-medium" data-id="element-3245">
                  Beneficios Disponibles
                </p>
                <p className="text-2xl font-bold text-gray-900" data-id="element-3246">
                  {totalRewardsAvailable}
                </p>
              </div>
            </div>
          </Card>
          <Card className="p-6" data-id="element-3247">
            <div className="flex items-center gap-4" data-id="element-3248">
              <div className="w-12 h-12 bg-purple-50 rounded-xl flex items-center justify-center shrink-0" data-id="element-3249">
                <Trophy className="w-6 h-6 text-purple-600" data-id="element-3250" />
              </div>
              <div data-id="element-3251">
                <p className="text-sm text-gray-500 font-medium" data-id="element-3252">
                  Beneficios Redimidos
                </p>
                <p className="text-2xl font-bold text-gray-900" data-id="element-3253">
                  {totalRewardsRedeemed}
                </p>
              </div>
            </div>
          </Card>
        </div>

        {/* Customer Table */}
        <Card className="overflow-hidden" data-id="element-3254">
          <div className="p-6 border-b border-gray-200" data-id="element-3255">
            <h2 className="font-bold text-gray-900" data-id="element-3256">Directorio de Clientes</h2>
          </div>
          <div className="overflow-x-auto" data-id="element-3257">
            <table className="w-full text-left text-sm" data-id="element-3258">
              <thead className="bg-gray-50 text-gray-500" data-id="element-3259">
                <tr data-id="element-3260">
                  <th className="px-6 py-4 font-medium" data-id="element-3261">Cliente</th>
                  <th className="px-6 py-4 font-medium" data-id="element-3262">Teléfono</th>
                  <th className="px-6 py-4 font-medium text-right" data-id="element-3263">Visitas</th>
                  <th className="px-6 py-4 font-medium text-right" data-id="element-3264">
                    Total Gastado
                  </th>
                  <th className="px-6 py-4 font-medium text-right" data-id="element-3265">
                    Ticket Promedio
                  </th>
                  <th className="px-6 py-4 font-medium text-right" data-id="element-3266">Puntos</th>
                  <th className="px-6 py-4 font-medium" data-id="element-3267">Nivel</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200" data-id="element-3268">
                {loading ? <tr data-id="element-3269">
                    <td colSpan={7} className="px-6 py-8 text-center text-gray-500" data-id="element-3270">
                      Cargando clientes...
                    </td>
                  </tr> : customers.length === 0 ? <tr data-id="element-3271">
                    <td colSpan={7} className="px-6 py-8 text-center text-gray-500" data-id="element-3272">
                      No hay clientes registrados aún.
                    </td>
                  </tr> : customers.map(customer => <tr key={customer.customer_id} className="hover:bg-gray-50" data-id="element-3273">
                      <td className="px-6 py-4 font-medium text-gray-900" data-id="element-3274">
                        {customer.name || 'Sin nombre'}
                      </td>
                      <td className="px-6 py-4 text-gray-500" data-id="element-3275">
                        {customer.phone}
                      </td>
                      <td className="px-6 py-4 text-right text-gray-900" data-id="element-3276">
                        {customer.total_orders}
                      </td>
                      <td className="px-6 py-4 text-right text-gray-900" data-id="element-3277">
                        {formatCurrency(customer.total_spent, restaurant.currency_symbol)}
                      </td>
                      <td className="px-6 py-4 text-right text-gray-500" data-id="element-3278">
                        {formatCurrency(customer.total_spent / Math.max(1, customer.total_orders), restaurant.currency_symbol)}
                      </td>
                      <td className="px-6 py-4 text-right font-bold text-brand-charcoal" data-id="element-3279">
                        {customer.current_points}
                      </td>
                      <td className="px-6 py-4" data-id="element-3280">
                        <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800" data-id="element-3281">
                          {customer.current_level || 'Inicial'}
                        </span>
                      </td>
                    </tr>)}
              </tbody>
            </table>
          </div>
        </Card>
      </div>
    </AdminLayout>;
}